module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-1.bc57fb5a.jpg";